<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('scegli_piatti')}}</h5>
        </div>
        <div slot="body">
            <div class="alert alert-info" v-if="this.errors.length">
                <ul>
                    <li v-for="(error, i) in this.errors" :key="i">
                        {{error}}
                    </li>
                </ul>
            </div>
            <div class="w-100 border-bottom pb-3" v-for="category in this.categories">
                <div class="mt-3 mb-2">
                    <b>
                        <span class="text-uppercase">{{category.nome_categoria}}</span>:
                    </b>
                    <br>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-2"
                     v-for="product in category.prodotti">
                    <div class="nome-scelte">
                        <b>{{product.nome_prodotto}}</b>
                        <span v-if="product.prezzo">
                            <span v-if="priceType === 'FISSO'">
                                 {{(product.prezzo < 0 ? ' - ' : ' + ')}} {{Math.abs(product.prezzo).toFixedGood(2)}}
                            </span>
                            <span v-else>
                                {{product.prezzo.toFixedGood(2)}}
                            </span> {{locale_currency}}
                        </span>
                    </div>
                    <div class="quantita-scelte">
                        <button class="btn btn-circle" @click="removePick(category, product)">
                            <i class="fa fa-minus"></i>
                        </button>
                        <span>{{getQuantity(category.id_categoria, product.id_prodotto)}}</span>
                        <button class="btn btn-circle" @click="addPick(category, product)"
                                :disabled="!canAdd(category)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary" @click="save()">
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    import Modal from '../../partials/Modal';

    import {canAddProductInCombo} from '../../../libraries/utils';

    export default {
        name: "ModalComboPicks",
        components: {Modal},
        props: ['categories', 'min_prod', 'max_prod', 'associated', 'priceType'],
        data() {
            return {
                picked: this.associated,
                errors: [],
            }
        },
        computed: {
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        },
        methods: {
            addPick: function (category, product) {
                const pickIndex = this.picked.findIndex((pick) => {
                    return pick.id_categoria === category.id_categoria && pick.id_prodotto === product.id_prodotto;
                });

                const copied = this.picked.slice();

                if (pickIndex !== -1) {
                    copied[pickIndex].qta++;
                    copied[pickIndex].totale = copied[pickIndex].prezzo * copied[pickIndex].qta;
                } else {
                    copied.push({
                        id_prodotto_composto_categoria_prodotto: product.id,
                        id_prodotto_composto_categoria: category.id,
                        id_categoria: category.id_categoria,
                        nome_categoria: category.nome_categoria,
                        nome_prodotto: product.nome_prodotto,
                        id_prodotto: product.id_prodotto,
                        qta: 1,
                        prezzo: product.prezzo,
                        totale: product.prezzo,
                        ingredienti: product.ingredienti,
                        foto_codice: product.foto_codice
                    });
                }

                this.picked = copied;
            },
            removePick: function (category, product) {
                const pickIndex = this.picked.findIndex((pick) => {
                    return pick.id_categoria === category.id_categoria && pick.id_prodotto === product.id_prodotto;
                });

                if (pickIndex !== -1) {
                    const copied = this.picked.slice();
                    copied[pickIndex].qta--;
                    copied[pickIndex].totale = copied[pickIndex].prezzo * copied[pickIndex].qta;

                    if (copied[pickIndex].qta <= 0) {
                        copied.splice(pickIndex, 1);
                    }

                    this.picked = copied;
                }
            },
            getPick: function (category_id, product_id) {
                return this.picked.find((pick) => {
                    return pick.id_categoria === category_id && pick.id_prodotto === product_id;
                });
            },
            getQuantity: function (category_id, product_id) {
                const pick = this.getPick(category_id, product_id);

                return pick ? pick.qta : 0;
            },
            canAdd: function (category) {
                return canAddProductInCombo(category, this.picked, this.max_prod);
            },
            save: function () {
                this.errors = [];
                let globalError = false;
                if (this.min_prod) {
                    if (this.picked.reduce((accumulator, pick) => {
                        return accumulator + pick.qta;
                    }, 0) < this.min_prod) {
                        this.errors.push(this.$tc("alert_combo_picks_min_prod", this.min_prod));
                        globalError = true;
                    }
                }

                let first = true;
                this.categories.forEach((category) => {

                    const min_prod_selezionabili = category.min_prod_selezionabili;

                    if (min_prod_selezionabili) {
                        if (this.picked.reduce((accumulator, pick) => {
                            if (pick.id_categoria === category.id_categoria)
                                return accumulator + pick.qta;
                            else
                                return accumulator;
                        }, 0) < min_prod_selezionabili) {
                            let error = '';
                            if (globalError) {
                                if (first) {
                                    error += this.$t("di_cui") + " ";
                                }

                                error += this.$tc("n_prodotti", min_prod_selezionabili) + " ";
                            } else {
                                error += this.$tc("alert_combo_picks_min_prod", min_prod_selezionabili) + " ";
                            }
                            error += this.$t("della_categoria", {category: category.nome_categoria});

                            this.errors.push(error);
                        }
                    }
                });

                if (!this.errors.length) {
                    this.$emit('close', this.picked);
                }
            }
        }
    }
</script>
